import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExternalService } from "../../services/external";
import { KeyValuePair, Project, SelectItem } from "../../../SharedModule/types/shared-module-types";
import { formatForDropdowns } from "../../../SharedModule/utils/formatters";

export const fetchMetaProducts = async () => {
  const [productsProjects, productsClients] = await Promise.all([
    ExternalService.getProjects(),
    ExternalService.getClients(),
  ]);

  const clientsProducts = productsClients.map(
    formatForDropdowns<KeyValuePair | Project>("name")
  );

  return {
    projectsProducts:
      productsProjects?.map((proj) => ({
        value: proj.id,
        label: `${proj.id} - ${proj.name}`,
        client: proj.accountId,
      })) || [],
    clientsProducts,
  };
};

export type MetaProductsState = {
  clientsProducts: Array<SelectItem> | null;
  projectsProducts: Array<any> | null;
  productsDataloaded: boolean;
};

type SetItem = Partial<MetaProductsState>;

const initialState: MetaProductsState = {
  clientsProducts: null,
  projectsProducts: null,
  productsDataloaded: false,
};

export const metaSlice = createSlice({
  name: "metaProducts",
  initialState,
  reducers: {
    // Remember Redux Toolkit allows us to write "mutating" logic in reducers.
    setMetaProducts: (
      state: MetaProductsState,
      action: PayloadAction<SetItem>
    ) => {
      return { ...state, ...action.payload, productsDataloaded: true };
    },
  },
});

export const { setMetaProducts } = metaSlice.actions;

// Selectors
export const SelectProductsMetaLoaded = ({
  metaProducts,
}: {
  metaProducts: MetaProductsState;
}) => metaProducts.productsDataloaded;

export const selectClients = ({
  metaProducts,
}: {
  metaProducts: MetaProductsState;
}) => metaProducts.clientsProducts;

export const selectProjects = ({
  metaProducts,
}: {
  metaProducts: MetaProductsState;
}) => metaProducts.projectsProducts;

export const selectRecurringOptions = (state: {
  metaProducts: MetaProductsState;
}) => {
  return {
    productsDataloaded: SelectProductsMetaLoaded(state),
    clientsProducts: selectClients(state),
    projectsProducts: selectProjects(state),
  };
};

export default metaSlice.reducer;
